module.exports = __webpack_public_path__ + "img/1557279827.e9d1eacf.jpg";